<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAlert_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M13.966 4.081c-.871-1.508-3.05-1.508-3.92 0L2.206 17.66c-.87 1.508.218 3.394 1.96 3.394h15.68c1.741 0 2.83-1.886 1.959-3.394L13.965 4.08ZM12.01 18.503c.588 0 1.064-.479 1.064-1.07 0-.59-.476-1.07-1.064-1.07h-.011c-.588 0-1.065.48-1.065 1.07 0 .591.477 1.07 1.065 1.07h.01Zm-1.065-5.349c0 .591.477 1.07 1.065 1.07s1.064-.479 1.064-1.07V8.875c0-.59-.476-1.07-1.064-1.07-.588 0-1.065.48-1.065 1.07v4.28Z"
        clip-rule="evenodd"
    />
</svg>
